import thLocale from 'element-ui/lib/locale/lang/th'
export default {
  ...thLocale,
  1127: 'ดาวน์โหลด',
  1128: 'เข้าสู่ระบบ',
  1129: 'ตลาดฮิวจ์',
  1130: 'สกุลเงิน',
  1131: 'ราคา',
  1132: 'เปลี่ยน',
  1133: 'กราฟ',
  1134: 'รายละเอียด',
  1135: 'สร้างผลงาน cryptocurrency ของคุณตอนนี้',
  1136: '{appName} มีคุณสมบัติหลายอย่างที่ทำให้เป็นที่ที่ดีที่สุดในการเริ่มต้นซื้อขาย',
  1137: 'จัดการพอร์ตโฟลิโอของคุณ',
  1138: 'ซื้อและขายสกุลเงินดิจิทัลยอดนิยมและติดตามทั้งหมดในที่เดียว',
  1139: 'การซื้อซ้ำ',
  1140: 'ลงทุนใน cryptocurrencies อย่างช้าๆโดยการจัดซื้อรายวันรายสัปดาห์หรือรายเดือน',
  1141: 'การป้องกันห้องนิรภัย',
  1142: 'เพื่อความปลอดภัยที่เพิ่มขึ้น ให้เก็บเงินของคุณไว้ในตู้นิรภัยและถอนเงินล่าช้า',
  1143: 'แอพมือถือ',
  1144: 'อยู่เหนือตลาดด้วยแอป {appName} สำหรับ Android หรือ iOS',
  1145: 'ในขณะที่การซื้อขายแบบเลเวอเรจในคู่เงินที่แปลกใหม่ จะดีกว่าถ้ามีเซิร์ฟเวอร์ Discord ที่เต็มไปด้วยมีมและอัลฟ่า',
  1146: 'ติดต่อเรา',

  11081: 'แพลตฟอร์มการซื้อขายชั้นยอด: ให้การซื้อขายเป็นไปอย่างรวดเร็ว มีเสถียรภาพและมีประสิทธิภาพ',
  11031: 'รองรับพีซีหลายเครื่องและระบบปฏิบัติการมือถือ',
  1126: 'แพลตฟอร์มการซื้อขาย',
  11261: 'แพลตฟอร์มการซื้อขาย Forex ยอดนิยม',
  11191: 'เปิดธุรกรรมทุกที่ทุกเวลา',
  nav0: 'หน้าแรก',
  nav1: 'คำพูด',
  nav2: 'ธุรกรรมเหรียญ',
  nav3: 'ธุรกรรมตามสัญญา',
  nav3_2: 'ธุรกรรมตามสัญญา',
  nav3_3: 'บัญชีสัญญา',
  nav4: 'การจัดการการเงิน',
  nav5: 'คำอธิบายข้อกำหนด',
  nav6: 'ข้อตกลงผู้ใช้',
  nav7: 'นโยบายความเป็นส่วนตัว',
  nav8: 'คำชี้แจงทางกฎหมาย',
  nav9: 'ข้อกำหนดการซื้อขาย',
  nav10: 'มือใหม่ช่วย',
  nav11: 'คำถามที่พบบ่อย',
  nav12: 'อัตราค่าธรรมเนียมการทำธุรกรรม',
  nav13: 'เกี่ยวกับเรา',
  nav14: 'บริการ',
  operate: 'การดำเนินงาน',
  homeTitle_1_1: 'แพลตฟอร์มการซื้อขายสินทรัพย์ดิจิทัลชั้นนำของโลก',
  homeTitle_1_2: 'แพลตฟอร์มการซื้อขายสินทรัพย์ดิจิทัลที่ได้รับความนิยมมากที่สุด เข้าถึงการวิเคราะห์ทางเทคนิคและเครื่องมือการซื้อขายที่มีประสิทธิภาพและสะดวกสบายที่สุดในตลาด ',
  register: 'ลงทะเบียนเลย',
  nowtrans: 'เข้าสู่ระบบ',
  logIn: 'อะไร',
  whats: 'WhatsApp',
  service: 'บริการ',
  home_1_2: 'หลักทรัพย์ Carrod คือการแลกเปลี่ยนเงินตราต่างประเทศที่เชื่อถือได้ของคุณ',
  home_1_3: 'โลหะมีค่า, แพลตฟอร์ม CFD',
  home_2_1: 'เงินของลูกค้าถูกเก็บไว้อย่างปลอดภัยในกองทุนทรัสต์แยกระดับ AA ระดับโลก',
  home_2_2: 'สเปรดที่ต่ำกว่าและเซิร์ฟเวอร์ที่เสถียรกว่า',
  footer1: `คำเตือนเกี่ยวกับความเสี่ยง: ผลิตภัณฑ์ทางการเงินที่บริษัทจัดหาให้นั้นรวมถึงสัญญาสำหรับส่วนต่าง ('CFD') และผลิตภัณฑ์ทางการเงินที่ซับซ้อนอื่นๆ การซื้อขาย CFD นั้นมีความเสี่ยงสูง เนื่องจากเลเวอเรจสามารถเป็นได้ทั้งดีและไม่ดีสำหรับคุณในเวลาเดียวกัน ดังนั้น CFD อาจไม่เหมาะสำหรับนักลงทุนทุกราย เนื่องจากอาจสูญเสียเงินต้นการลงทุนทั้งหมดของคุณ คุณไม่ควรลงทุนเงินที่คุณไม่สามารถจะสูญเสียได้ ก่อนทำการซื้อขายผลิตภัณฑ์ทางการเงินที่ซับซ้อน โปรดตรวจสอบให้แน่ใจว่าได้เข้าใจความเสี่ยงที่เกี่ยวข้อง คุณได้รับสิทธิ์ไม่จำกัดเฉพาะและไม่สามารถถ่ายโอนได้ในการใช้ IP ที่ให้ไว้บนเว็บไซต์นี้เพื่อวัตถุประสงค์ส่วนตัวและไม่ใช่เชิงพาณิชย์ที่เกี่ยวข้องกับบริการที่มีให้บนเว็บไซต์เท่านั้น `,
  footer2: 'โปรดทราบว่าข้อมูลบนเว็บไซต์นี้ไม่ได้มุ่งเป้าไปที่ผู้อยู่อาศัยในประเทศหรือเขตอำนาจศาลใด ๆ ที่แตกต่างจากกฎหมายและข้อบังคับที่อธิบายไว้ในเว็บไซต์ Carrod Securities Co Ltd ไม่ใช่ที่ปรึกษาทางการเงินและมีเพียงคำแนะนำทั่วไปเท่านั้น . จะไม่ออกความคิดเห็นหรือข้อเสนอแนะใด ๆ เกี่ยวกับการได้มา การถือครอง หรือการขายการซื้อขายมาร์จิ้น',
  1: 'ชื่อผลิตภัณฑ์',
  2: 'อัตราผลตอบแทนที่คาดหวังต่อวัน',
  3: 'สินค้าหมดเขต',
  4: 'จำนวนเงินลงทุนเริ่มต้น',
  5: 'การดำเนินงาน',
  6: 'ซื้อ',
  7: 'การจัดการสกุลเงินที่เหลืออยู่',
  8: 'การจัดการทางการเงินที่ยืดหยุ่น รับทุกวัน',
  9: 'เกี่ยวกับเรา',
  10: 'ข้อตกลงผู้ใช้',
  11: 'นโยบายความเป็นส่วนตัว',
  12: 'คำชี้แจงทางกฎหมาย',
  13: 'กฎการซื้อขาย',
  14: 'คำอธิบายข้อกำหนด',
  15: 'บริการ',
  16: 'มือใหม่ช่วย',
  17: 'คำถามที่พบบ่อย',
  18: 'อัตราค่าธรรมเนียมการทำธุรกรรม',
  19: 'ระบบการซื้อขายสัญญาที่สองของสกุลเงินดิจิทัล',
  20: 'รวดเร็ว สะดวก ไม่แบ่งแยก ควบคุมความเสี่ยงได้',
  21: 'แนะนำระบบ',
  22: 'ด้วยการพัฒนาอย่างรวดเร็วของฟิวเจอร์สสกุลเงินดิจิทัล ผู้ใช้ส่วนใหญ่มีสินทรัพย์มากขึ้นเรื่อยๆ และวิธีการซื้อขายของสกุลเงินเสมือนก็มีความหลากหลายเช่นกัน ผู้ใช้ติดตามวิธีการชำระธุรกรรมที่รวดเร็วและมีประสิทธิภาพมากขึ้นเรื่อย ๆ ด้วยเหตุนี้ สัญญาที่สองจึงได้รับการยกย่องอย่างสูง สัญญาที่สองที่เปิดตัวโดย Mutual Cloud เป็นระบบการซื้อขายสำหรับการชำระสัญญาสกุลเงินเสมือนในหน่วยเซนต์ ระบบรองรับการซื้อขายราคาตลาดและการซื้อขายแบบจำกัดราคา ผู้ใช้สามารถซื้อ call และ put option ด้วยการลงทุนขนาดเล็ก เกณฑ์ต่ำ และรอบการชำระสั้น แบ่งเป็น 1 นาที 2 นาที 3 นาที เป็นต้น และระบบสามารถ กำหนดค่าได้อย่างอิสระ ระบบมีระบบควบคุมความเสี่ยงที่เข้มงวด โดยมีการตั้งค่าความผันผวนสูงสุดและต่ำสุด หากเกินขีดจำกัด อัตราต่อรองจะถูกรีเซ็ตโดยอัตโนมัติเป็นศูนย์ ',
  23: 'K สายแหล่งที่มา',
  24: 'การซื้อขายส่วนใหญ่ขึ้นอยู่กับราคาตลาดของการแลกเปลี่ยนภายนอกสำหรับการซื้อขาย',
  25: 'สกุลเงินสนับสนุน',
  251: 'วิธีการฝากเงิน',
  252: 'ฝากเหรียญ',
  26: 'เติมเงินผ่านที่อยู่กระเป๋าเงิน',
  27: 'ซื้อผ่านธุรกรรม C2C',
  28: 'ตอบสนองความต้องการของแพลตฟอร์มในการออกเหรียญ',
  281: 'ซื้อผ่านธุรกรรม OTC',
  282: 'แพลตฟอร์มไม่จำเป็นต้องแบกรับความเสี่ยงของสกุลเงินที่ลอยตัว',
  29: 'การออกแบบแบบจำลองสัญญา',
  30: 'วิธีการซื้อขาย',
  31: 'การตั้งค่าเวลาการชำระเงิน',
  32: 'ทิศทางการค้า',
  33: 'การควบคุมธุรกรรม',
  34: 'การควบคุมความเสี่ยง',
  35: 'จำกัดการซื้อ',
  36: 'ป้องกันการสูญเสียขนาดใหญ่จากลูกค้า',
  38: 'กำหนดเส้นตายสำหรับการวางคำสั่งซื้อ',
  39: 'ตรวจสอบให้แน่ใจว่ามีเวลาชำระบัญชีเพียงพอสำหรับการเสมอ',
  40: 'ตั้งค่าขึ้นและลงบรรทัด',
  41: 'เรียกโอกาสให้เป็นศูนย์เพื่อป้องกันการทำธุรกรรมฝ่ายเดียว',
  42: 'หลีกเลี่ยงการสูญเสียขนาดใหญ่',
  43: 'ปุ่มปิดเพียงคลิกเดียว',
  44: 'ลูกค้าสามารถคลิกปุ่มเพื่อปิดสถานะในสถานการณ์ที่รุนแรงได้',
  46: 'การตรวจสอบบริการ',
  47: 'การตรวจสอบบริการที่ครอบคลุมเพื่อให้แน่ใจว่าตอบสนองต่อความล้มเหลวของบริการได้อย่างทันท่วงทีและเริ่มต้นการแจ้งเตือนทางอีเมลที่ล้มเหลวทันเวลา',
  48: 'บริการสนับสนุน',
  49: 'เราเข้าหาลูกค้าด้วยหัวใจ เรามีความกระตือรือร้น เอาใจใส่ อดทน และระมัดระวัง เรามีทีม R&D ซอฟต์แวร์มืออาชีพ การตรวจสอบและการจัดการแพลตฟอร์มที่เข้มงวด และทีมบริการแบบครบวงจรมืออาชีพ ',
  50: 'หนึ่ง เลือกคู่การซื้อขาย',
  51: 'สอง ตรวจสอบราคา',
  52: 'ดูราคาซื้อขายในตลาดและเลือกราคาที่เหมาะสมในการสั่งซื้อ ',
  53: 'สาม ซื้อหลังจากกรอกคำสั่ง',
  54: 'เลือกคู่ธุรกรรมที่ต้องการซื้อ (ธุรกรรมสกุลเงินต่อสกุลเงินหมายถึงการใช้สินทรัพย์ดิจิทัลหนึ่งเพื่อแลกเปลี่ยนกับสินทรัพย์ดิจิทัลอื่น)',
  55: 'กรอกราคาซื้อและปริมาณการซื้อ และรอการทำธุรกรรมในตลาด ',
  57: 'เข้าใจธุรกรรมสกุลเงินในไม่กี่วินาที',
  58: 'ธุรกรรมที่ปลอดภัยและเชื่อถือได้ รวดเร็ว',
  59: 'ราคาซื้อขาย',
  60: 'มีในสต็อก',
  601: 'มอบสินทรัพย์ดิจิทัลขั้นสูง CFD และแพลตฟอร์มการซื้อขายสินค้าโภคภัณฑ์แก่นักลงทุนทั่วโลก',
  61: 'จุดไหน? ',
  62: 'สปอตสำหรับฟิวเจอร์ส สปอตและฟิวเจอร์สคล้ายกัน ความแตกต่างหลักอยู่ที่ความแตกต่างของเลเวอเรจและมาร์จิ้น เวลาการส่งมอบธุรกรรม ฯลฯ',
  63: 'ฟิวเจอร์ส',
  64: 'ฟิวเจอร์สคืออะไร',
  65: 'สัญญาซื้อขายล่วงหน้าเรียกว่าฟิวเจอร์สเป็นวิธีการซื้อขายที่มีระยะเวลานาน โดยการลงนามในสัญญา ผู้ซื้อและผู้ขายตกลงที่จะส่งมอบสปอตตามจำนวนที่กำหนดตามเวลา ราคา และเงื่อนไขการซื้อขายอื่นๆ ที่กำหนด ',
  66: 'ไว้วางใจการจัดการทางการเงิน',
  67: 'การจัดหาเงินทุนที่เชื่อถือได้คืออะไร',
  68: 'การเงินแบบกระจายอำนาจเป็นการเงินแบบ blockchain มันไม่ได้พึ่งพาสถาบันการเงินเช่นนายหน้าการแลกเปลี่ยนหรือธนาคารในการจัดหาเครื่องมือทางการเงิน แต่ใช้สัญญาอัจฉริยะบน blockchain เพื่อดำเนินกิจกรรมทางการเงิน',
  69: 'C2C',
  70: 'C2C คืออะไร',
  71: 'C2C หรือที่เรียกว่า "ส่วนตัวต่อส่วนตัว" เป็นรูปแบบของการทำธุรกรรมซึ่งหมายถึงรูปแบบการทำธุรกรรมระหว่างบุคคลต่อบุคคล ',
  72: 'บริการซื้อขายแบบครบวงจร',
  73: 'ชื่อ',
  74: 'ราคา',
  75: 'ขึ้นและลง 24 ชั่วโมง',
  76: 'ระดับเสียง 24 ชั่วโมง',
  77: 'คำคม',
  78: 'การรวมที่เสถียรและปลอดภัย',
  79: 'การป้องกันความปลอดภัยระดับการเงิน',
  80: 'เทคโนโลยีความเป็นส่วนตัวและการรักษาความลับที่ปราศจากอคติที่ปราศจากอคติในการปกป้องความเป็นส่วนตัวของผู้ใช้ ลายเซ็นหลายรายการ สถาปัตยกรรมแบบเลเยอร์ และการออกแบบความปลอดภัยอื่นๆ ',
  81: 'เครื่องมือจับคู่ประสิทธิภาพสูง',
  82: 'ใช้สถาปัตยกรรมคลัสเตอร์แบบกระจายขั้นสูงและวิธีการพัฒนาไมโครเซอร์วิส รองรับธุรกรรมมากกว่า 3 ล้านรายการต่อวินาทีพร้อมกัน ',
  83: 'บริการต่อเนื่องตลอด 24 ชั่วโมง',
  84: 'ฝ่ายบริการลูกค้าออนไลน์ตลอด 24 ชั่วโมง เจ็ดวันต่อสัปดาห์ เพื่อตอบคำถามต่างๆ ให้กับคุณ ',
  85: 'เปิดธุรกรรมได้ทุกที่ทุกเวลา',
  86: 'การแก้ไขใหม่เอี่ยมเพื่อตอบสนองความต้องการในการซื้อขายของสถานการณ์ต่างๆ ได้ตลอดเวลา',
  87: '24*7 ชั่วโมงทุกสภาพอากาศ โหมดการทำงานเต็มเวลา ฝ่ายบริการลูกค้าจะตอบคำถามที่เกี่ยวข้องของคุณโดยเร็วที่สุด ',
  88: 'คู่ซื้อขาย',
  89: 'ราคาล่าสุด',
  90: 'ขึ้นและลง',
  91: 'ราคาสูงสุด',
  92: 'ราคาต่ำสุด',
  93: 'ระดับเสียง',
  94: 'เข้าสู่ระบบ',
  95: 'ลงทะเบียน',
  fee: {
    1: 'อัตราค่าธรรมเนียมการทำธุรกรรม',
    2: 'ค่าธรรมเนียมการทำธุรกรรมสกุลเงิน',
    3: 'ค่าธรรมเนียมการทำธุรกรรมตามสัญญา'
  },
  law: {
    1: 'คำชี้แจงทางกฎหมาย',
    2: 'บทความแรก',
    3: 'แพลตฟอร์มนี้มุ่งมั่นที่จะสร้างสภาพแวดล้อมการซื้อขายสินทรัพย์ดิจิทัลที่เป็นไปตามข้อกำหนด ปลอดภัยและเชื่อถือได้สำหรับผู้ใช้ และห้ามไม่ให้ผู้ใช้ใช้เว็บไซต์นี้เพื่อมีส่วนร่วมในการฟอกเงิน การลักลอบขนสินค้า การติดสินบนในเชิงพาณิชย์ การยักยอกตลาดโดยมุ่งร้าย และกิจกรรมการซื้อขายที่ผิดกฎหมายอื่น ๆ หรือผิดกฎหมาย กิจกรรม. ด้วยเหตุนี้ เราจึงพยายามอย่างเต็มที่ในการกำหนดโปรแกรมต่อต้านการฟอกเงินและการต่อต้านการก่อการร้ายที่เข้มงวด และใช้มาตรการควบคุมความเสี่ยงด้านความปลอดภัยที่มีประสิทธิภาพเพื่อเพิ่มการปกป้องสิทธิ์ที่ถูกต้องตามกฎหมายและผลประโยชน์ของผู้ใช้ และรักษาชื่อเสียงของแบรนด์ให้ดีบนแพลตฟอร์ม ตัวเอง',
    4: 'บทความที่สอง',
    5: 'เมื่อหน่วยงานผู้มีอำนาจจัดทำเอกสารการสอบสวนที่เกี่ยวข้องและขอให้เว็บไซต์นี้ร่วมมือในการตรวจสอบผู้ใช้ที่ได้รับมอบหมาย หรือเมื่อมีการใช้มาตรการต่างๆ เช่น การปิดผนึก การระงับ หรือการโอนบัญชีผู้ใช้ เว็บไซต์นี้จะตรวจสอบความถูกต้องและความถูกต้องของเอกสารการพิจารณาคดี หลังจากมีเพศสัมพันธ์ ตามข้อกำหนดของหน่วยงานผู้มีอำนาจที่กำหนดโดยแพลตฟอร์มเพื่อช่วยในการให้ข้อมูลผู้ใช้ที่เกี่ยวข้องหรือดำเนินการที่เกี่ยวข้อง การรั่วไหลของความเป็นส่วนตัวของผู้ใช้ บัญชีใช้งานไม่ได้ และความสูญเสียอื่น ๆ ที่เกิดจากผู้ใช้ ฯลฯ เกิดจากสิ่งนี้ เว็บไซต์ เราไม่รับผิดชอบใด ๆ ',
    6: 'ข้อ 3',
    7: 'ผู้ใช้ทุกคนที่ใช้บริการของเว็บไซต์นี้ควรรู้ก่อนทำการซื้อขาย: สินทรัพย์ดิจิทัลไม่ได้รับการสนับสนุนจากรัฐบาลหรือธนาคารกลางใด ๆ และราคาของสินทรัพย์ดิจิทัลมีความผันผวนอย่างมาก การถือครองหรือการใช้สินทรัพย์ดิจิทัลมีความเสี่ยงสูง ก่อนตัดสินใจซื้อขาย คุณควรมีเหตุผลและรอบคอบกับสถานการณ์ทางการเงินของคุณเองเพื่อพิจารณาว่าเหมาะสมกับคุณหรือไม่',
    8: 'ข้อ 4',
    9: 'ใครก็ตามที่เข้าสู่ระบบเว็บไซต์นี้ไม่ว่าด้วยวิธีใดหรือโดยทางตรงหรือทางอ้อมที่ใช้บริการของเว็บไซต์นี้จะถือว่ายอมรับข้อจำกัดของคำชี้แจงของเว็บไซต์นี้โดยสมัครใจ '
  },
  rules: {
    1: 'กฎการซื้อขาย',
    2: 'หลังจากสร้างคำสั่งซื้อ ผู้ซื้อควร:',
    3: '1 ชำระเงินให้เสร็จสิ้นภายในเวลาชำระเงินที่ระบุในคำสั่งซื้อ จากนั้นคลิก "ฉันชำระเงินแล้ว";',
    4: '2 ใช้วิธีการชำระเงินด้วยชื่อจริงของฉัน ชำระเงินตามคำสั่งซื้อตามจำนวนการสั่งซื้อและบัญชีการชำระเงินที่กำหนดโดยคำสั่งซื้อเพื่อให้การชำระเงินตามคำสั่งซื้อเสร็จสมบูรณ์แบบเรียลไทม์',
    5: '3. หากคุณเลือกวิธีการชำระเงินที่ไม่ใช่แบบเรียลไทม์เพื่อชำระเงินสำหรับการสั่งซื้อ คุณต้องได้รับความยินยอมจากผู้ขายล่วงหน้า',
    6: '4. คำสั่งการชำระเงินจะต้องไม่ระบุ "สกุลเงินดิจิทัล BTC Bitcoin" และข้อมูลอื่น ๆ ',
    7: 'หลักการที่ผู้ขายควรปฏิบัติตาม',
    8: 'หลังจากสร้างคำสั่งซื้อแล้ว ผู้ขายควร',
    9: '1. ระบุบัญชีรับที่รับรองโดยแพลตฟอร์ม',
    10: '2 หลังจากได้รับการชำระเงินเต็มจำนวนจากผู้ซื้อแล้ว ให้ดำเนินการเผยแพร่ให้เสร็จสิ้นภายในเวลาที่ระบุไว้ในคำสั่งซื้อ',
    11: '3. หากไม่ได้รับความยินยอมจากผู้ซื้อ ผู้ซื้อ/ฝ่ายบริการลูกค้าไม่จำเป็นต้องยกเลิกคำสั่งซื้อ',
    12: '4. หากไม่ได้รับความยินยอมจากผู้ซื้อ จะไม่มีการคัดค้านราคาคำสั่งที่สร้างขึ้นได้'
  },
  help: {
    1: 'มือใหม่ช่วย',
    2: 'คำสั่งจำกัด',
    3: 'คำสั่งซื้อ/ขายในราคาที่กำหนดหรือดีกว่า ',
    4: 'คำสั่งซื้อของตลาด',
    5: 'คำสั่งซื้อหรือขายทันทีที่ราคาตลาดปัจจุบัน ',
    6: 'คำสั่งจำกัดการหยุดการขาดทุน',
    7: 'คำสั่งขายหรือปิดตำแหน่งในราคาที่กำหนดหลังจากที่ตลาดถึงราคาที่แน่นอนเพื่อควบคุมการขาดทุน ',
    8: 'จำกัดราคา Take Profit Order',
    9: 'คล้ายกับคำสั่งหยุด-จำกัด มันคือคำสั่งขายหรือปิดตำแหน่งที่ราคากำหนดหลังจากที่ตลาดถึงราคาหนึ่ง ซึ่งใช้เพื่อควบคุมกำไร ',
    10: 'คำสั่งหยุดการขาดทุนของตลาด',
    11: 'คำสั่งขายหรือปิดตำแหน่งที่ราคาตลาดหลังจากที่ตลาดถึงราคาที่แน่นอนเพื่อควบคุมการขาดทุน ',
    12: 'ราคาตลาด Take Profit Order',
    13: 'คล้ายกับคำสั่งหยุดการขาดทุนของตลาด ยังเป็นคำสั่งขายหรือปิดตำแหน่งที่ราคาตลาดหลังจากที่ตลาดถึงราคาหนึ่ง ซึ่งใช้เพื่อควบคุมกำไร ',
    14: 'มาร์จิ้นสำหรับการเปิดสถานะคืออะไร? ',
    15: 'การซื้อขายด้วยหลักประกันหมายความว่าคุณจะต้องจ่ายเพียงร้อยละหนึ่งของมาร์จิ้นเพื่อซื้อและขายสัญญา ตามเลเวอเรจที่เลือก อัตรามาร์จิ้นจะน้อยกว่ามูลค่าสัญญาหลายเท่า มันสามารถขยายผลกำไรของคุณ แต่อาจทำให้คุณมีความเสี่ยงเพิ่มเติม ',
    16: 'การชำระบัญชีคืออะไร และการเจาะคืออะไร? ',
    17: 'เมื่อเงินคงเหลือในบัญชีของคุณน้อยกว่ากำไรขาดทุนลอยตัวที่กำหนดโดยสัญญาซื้อขาย สถานะของคุณจะถูกบังคับปิดโดยการแลกเปลี่ยน หรือที่เรียกว่าการชำระบัญชี เนื่องจากราคาเมื่อปิดโพซิชั่นถูกกำหนดตามราคาตลาด เมื่อราคาธุรกรรมไม่เอื้ออำนวยอย่างยิ่ง คุณอาจไม่มีเงินทุนเพียงพอที่จะครอบคลุมการสูญเสียของธุรกรรม ส่งผลให้เกิดมูลค่าติดลบในบัญชีของคุณ สถานการณ์นี้คือ เรียกว่าขาดตำแหน่ง ',
  },
  96: 'เลือกคู่ซื้อขาย',
  97: 'ตรวจสอบราคา',
  98: 'ซื้อหลังจากกรอกคำสั่งซื้อ',
  99: 'การเข้าสู่ระบบบัญชี',
  100: 'ยินดีต้อนรับกลับมา! เข้าสู่ระบบด้วยอีเมลหรือหมายเลขโทรศัพท์ของคุณ',
  101: 'กล่องจดหมาย',
  102: 'มือถือ',
  103: 'ลืมรหัสผ่าน? ',
  104: 'ลงทะเบียนเลย',
  105: 'รหัสผ่าน',
  106: 'กรุณาใส่หมายเลขโทรศัพท์ของคุณ',
  107: 'ข้อผิดพลาดรูปแบบหมายเลขโทรศัพท์มือถือ',
  108: 'กรุณากรอกอีเมล์',
  109: 'ข้อผิดพลาดรูปแบบกล่องจดหมาย',
  110: 'โปรดป้อนรหัสผ่าน',
  111: 'รหัสผ่านอย่างน้อย 6 ตัวอักษร',
  112: 'รหัสผ่านสูงสุด 32 บิต',
  113: 'ภาษาและภูมิภาค',
  114: 'สร้างบัญชี {appName}',
  115: 'ใช้อีเมลหรือหมายเลขโทรศัพท์มือถือของคุณเพื่อลงทะเบียน',
  116: 'รหัสคำแนะนำ',
  117: 'ตกลง',
  118: 'และ',
  119: 'ข้อตกลงผู้ใช้',
  120: 'นโยบายความเป็นส่วนตัว',
  121: 'ลงทะเบียน? ',
  122: 'รหัสยืนยัน',
  123: 'ส่ง',
  124: 'โปรดป้อนรหัสยืนยัน',
  125: 'รหัสยืนยันต้องเป็น 6 หลัก',
  126: 'รีเซ็ตรหัสผ่าน',
  127: 'โอเค',
  128: 'ใช้อีเมลหรือโทรศัพท์มือถือของคุณเพื่อรีเซ็ตรหัสผ่านสำหรับเข้าสู่ระบบ',
  129: 'การพิสูจน์ตัวตนด้วยชื่อจริง',
  130: 'การตรวจสอบชื่อจริงให้เสร็จสมบูรณ์จะช่วยปกป้องความปลอดภัยของบัญชี เพิ่มขีดจำกัดการถอนและสิทธิ์ในการทำธุรกรรม',
  131: 'ไปที่การรับรองความถูกต้อง',
  132: 'การรับรองความถูกต้อง',
  133: 'ใช้ในการเข้าสู่ระบบ ถอนเหรียญ เรียกรหัสผ่าน แก้ไขการตั้งค่าความปลอดภัย',
  134: 'ตรวจสอบแล้ว',
  135: 'การจัดการรหัสผ่าน',
  136: 'รหัสผ่านสำหรับเข้าสู่ระบบ',
  137: 'รหัสผ่านกองทุน',
  138: 'ใช้เพื่อปกป้องความปลอดภัยของบัญชี',
  139: 'ใช้เพื่อปกป้องความปลอดภัยของเงินทุน',
  140: 'การตั้งค่าส่วนบุคคล',
  141: 'การตั้งค่าสี',
  142: 'การตั้งค่า',
  143: 'แก้ไข',
  144: 'ตั้งค่าแผนภูมิแท่งเทียน ซื้อขึ้นและลงสี',
  145: 'วิธีการตั้งราคา',
  146: 'หน่วยการประเมินมูลค่าทรัพย์สินทางบัญชี',
  147: 'ค่าเริ่มต้น',
  148: 'สีเขียวขึ้นและสีแดงตก',
  149: 'แดงขึ้นและเขียวลง',
  150: 'แก้ไขรหัสผ่านเข้าสู่ระบบ',
  151: 'แก้ไขรหัสผ่านกองทุน',
  152: 'รหัสผ่านเก่า',
  153: 'รหัสผ่านใหม่',
  154: 'โปรดป้อนรหัสผ่านเก่า',
  155: 'หมายเลขโทรศัพท์ใหม่',
  156: 'กล่องจดหมายใหม่',
  157: 'ผูกหมายเลขโทรศัพท์มือถือ',
  158: 'ผูกกล่องจดหมาย',
  159: 'แก้ไขหมายเลขโทรศัพท์มือถือ',
  160: 'แก้ไขกล่องจดหมาย',
  161: 'รับรองความถูกต้อง',
  162: 'ตั้งชื่อเล่น',
  163: 'กรุณาใส่ชื่อเล่นของคุณ',
  164: 'ยกเลิก',
  165: 'ประเทศ',
  166: 'ชื่อ',
  167: 'นามสกุล',
  168: 'ประเภทใบรับรอง',
  169: 'หมายเลขใบรับรอง',
  170: 'กรุณาเลือกประเทศ',
  171: 'กรุณากรอกชื่อ',
  172: 'กรุณาใส่นามสกุล',
  173: 'กรุณาใส่หมายเลขประจำตัวประชาชน',
  174: 'โปรดอัปโหลดรูปด้านหน้าของบัตรประจำตัว',
  175: 'โปรดอัปโหลดรูปถ่ายด้านหลังบัตรประจำตัวของคุณ',
  176: 'โปรดอัปโหลดรูปถ่ายของบัตรประจำตัวที่คุณถืออยู่',
  177: 'ส่ง',
  178: 'การรับรอง',
  179: 'ID',
  180: 'หนังสือเดินทาง',
  181: 'ต่อไป',
  182: 'อัปโหลดรูปถ่ายติดบัตรและรับรองความถูกต้อง',
  183: 'การอัปโหลดล้มเหลว',
  184: 'รูปแบบรูปภาพผิดพลาด',
  185: 'รูปภาพใหญ่เกินไป',
  186: 'กำลังโหลด',
  187: 'ภาพรวมสินทรัพย์',
  188: 'โอน',
  189: 'การถอน',
  190: 'ฝากเหรียญ',
  191: 'บันทึกทางการเงิน',
  192: 'หยุด',
  193: 'ใช้ได้',
  194: 'รวม',
  195: 'ซ่อนสกุลเงินขนาดเล็ก',
  196: 'สกุลเงิน',
  197: 'การประเมินมูลค่า USDT',
  198: 'ค้นหา',
  199: 'เครือข่ายเติมเงิน',
  200: 'ที่อยู่ฝากเงิน',
  201: 'ที่อยู่ออกเหรียญ',
  202: 'ยอดเติมเงิน',
  203: 'ภาพหน้าจอของการฝากเหรียญ',
  204: 'ข้อสังเกต',
  205: 'คัดลอกที่อยู่',
  206: 'คัดลอกสำเร็จ',
  207: 'กลับมา',
  208: 'ไม่บังคับ',
  209: 'โปรดป้อนจำนวนเหรียญที่จะเติมเงิน',
  210: 'โปรดระบุหมายเลขที่ถูกต้อง',
  211: 'โปรดป้อนที่อยู่สกุลเงิน',
  212: 'โปรดอัปโหลดภาพหน้าจอของการฝากเหรียญ',
  213: 'ที่อยู่ถอนเงิน',
  214: 'จำนวนเงินที่ถอน',
  215: 'ยอดเงินคงเหลือ',
  216: 'ทั้งหมด',
  217: 'ค่าธรรมเนียมการจัดการ',
  218: 'โปรดป้อนจำนวนเหรียญที่ถอน',
  219: 'กรุณาใส่รหัสผ่านกองทุน',
  220: 'รหัสผ่านกองทุนต้องเป็น 6 หลัก',
  221: 'รหัสผ่านเริ่มต้น',
  222: 'คุณยังไม่ได้ผูกกระเป๋าเงินที่ตรงกัน! ',
  223: 'ไปที่เพิ่ม',
  224: 'ส่งสำเร็จ',
  225: 'เพิ่มกระเป๋าเงินคอลเลกชัน',
  226: 'ที่อยู่',
  227: 'กรุณาป้อนเครือข่าย',
  228: 'กรุณากรอกที่อยู่',
  229: 'เครือข่าย',
  230: 'เครือข่ายการถอน',
  231: 'ความยาวของที่อยู่คือต่ำสุด 32 บิต',
  232: 'การโอนเงิน',
  233: 'จำนวนเงินโอน',
  234: 'กรุณาระบุจำนวนเงินที่โอน',
  235: 'ความสมดุลไม่เพียงพอ',
  236: 'โอนได้',
  237: 'ปัดทิศทาง',
  238: 'โอน',
  239: 'จาก',
  240: 'ถึง',
  241: 'บันทึกทางการเงิน',
  242: 'บันทึกการฝากเหรียญ',
  243: 'บันทึกการถอน',
  244: 'บันทึกการโอน',
  245: 'จำนวน',
  246: 'สถานะ',
  247: 'สร้างเวลา',
  248: 'ยืนยันเวลา',
  249: 'ไม่มีอีกแล้ว',
  250: 'ราคา',
  253: 'คู่ซื้อขาย',
  254: 'ขึ้นและลง',
  255: 'ยังไม่มีข้อมูล',
  256: 'สะสม',
  257: 'สูง',
  258: 'ต่ำ',
  259: 'จำนวนมาก',
  260: 'เปิด',
  261: 'รับ',
  262: 'จำนวนเงิน',
  263: 'การซื้อขายล่วงหน้า',
  264: 'รั้น',
  265: 'หยาบคาย',
  266: 'ชื่อผลิตภัณฑ์',
  267: 'ดูสัญญา',
  268: 'ยอดซื้อ',
  269: 'กรุณาป้อนจำนวนเงินที่ซื้อ',
  270: 'ค่าธรรมเนียมการทำธุรกรรม',
  271: 'ซื้อขั้นต่ำ',
  272: 'สถานะ',
  273: 'รอการจัดส่ง',
  274: 'ส่งมอบแล้ว',
  275: 'คำสั่งซื้อสำเร็จ',
  276: 'ชื่อผลิตภัณฑ์',
  277: 'กำไรขาดทุน',
  278: 'ราคาซื้อ',
  279: 'ราคาส่ง',
  280: 'ซื้อขายต่อ',
  283: 'กำไร',
  284: 'ยืนยันการสั่งซื้อ',
  285: 'คำสั่งประวัติศาสตร์',
  286: 'คำสั่งถูกระงับ',
  287: 'เวลาที่สร้าง',
  288: 'ซื้อ',
  289: 'ขาย',
  290: 'จำนวนธุรกรรม',
  291: 'จำนวนธุรกรรม',
  292: 'สัญญา',
  293: 'เวลาจัดส่ง',
  294: 'ราคาส่ง',
  295: 'วินาที',
  296: 'นาที',
  297: 'ชั่วโมง',
  298: 'วัน',
  299: 'เวลาที่เหลืออยู่',
  300: 'ดูเพิ่มเติม',
  301: 'ธุรกรรมสกุลเงิน',
  302: 'จำนวนขาย',
  303: 'กรุณาป้อนจำนวนเงินที่ขาย',
  304: 'ธุรกรรมสกุลเงิน Fiat',
  305: 'สินทรัพย์',
  306: 'ออกจากระบบ',
  307: 'ลงทะเบียนเรียบร้อยแล้ว',
  308: 'โปรดป้อนคำแนะนำ',
  309: 'ความสำเร็จ',
  310: 'ล้มเหลว',
  311: 'ยืนยัน',
  312: 'วิธีการชำระเงิน',
  313: 'ที่อยู่ถอนเงิน',
  314: 'ลบ',
  315: 'ปฏิบัติการ',
  316: 'กระเป๋าเงินของคุณ',
  317: 'คุณแน่ใจหรือว่าต้องการลบ? ',
  318: 'ลบสำเร็จ',
  319: 'การตรวจสอบสิทธิ์ล้มเหลว',
  320: 'การรับรองซ้ำ',
  330: 'กระเป๋าเงินถอนสินทรัพย์ดิจิทัล',
  331: 'ผูกมัดบัตรธนาคาร ถอนเงินสดเป็นสกุลเงินคำสั่ง',
  332: 'โปรดป้อนที่อยู่ที่ถูกต้อง',
  1000: 'วัน',
  1001: 'กำลังดำเนินการ',
  1002: 'ปิด',
  1003: 'กฎ',
  1004: 'ความได้เปรียบของผลิตภัณฑ์',
  1005: 'บันทึกเท่าที่คุณทำ',
  1006: 'เงินปันผลหมดอายุ',
  1007: 'โบนัสรายวัน',
  1008: 'ดอกเบี้ยเงินฝากสด',
  1009: 'การค้ำประกันทุน 100%',
  1010: 'รายได้ปกติในช่วงวันหยุด',
  1011: 'พักผ่อนในวันถัดไป',
  1012: 'ความได้เปรียบของผลิตภัณฑ์',
  1013: 'สมาชิกฝากเงิน 200,000 USDT บนแพลตฟอร์ม เลือกผลิตภัณฑ์การบริหารความมั่งคั่งที่มีระยะเวลา 14 วันและรายได้รายวัน 0.5% และรายได้รายวันจะเป็นดังนี้: 200,000*0.5%=1,000 USDT นั่นคือ หลังจาก 14 วัน คุณจะ สามารถรับรายได้ 14,000 USDT และรายได้จะออกทุกวัน ฝากเงินต้น และเงินต้นจะถูกส่งคืนไปยังบัญชีของคุณโดยอัตโนมัติเมื่อครบกำหนด',
  1014: 'คำสั่งอารักขา',
  1015: 'โฮสติ้ง',
  1016: 'เสร็จสิ้น',
  1017: 'แลก',
  1018: 'ยังไม่มีข้อมูล',
  1019: 'ยอดซื้อ',
  1020: 'อัตราผลตอบแทนรายวัน',
  1021: 'ความไว้วางใจ.6',
  1022: 'เวลาชำระเงิน',
  1023: 'วันที่ไถ่ถอน',
  1024: 'หมดอายุ',
  1025: 'ล่าสุด (รายได้รายวัน)',
  1026: 'เงินปันผล',
  1027: 'ทุกวัน',
  1028: 'จำนวนอารักขา',
  1029: 'ส่งคืนเมื่อหมดอายุ',
  1030: 'ยอดเงินคงเหลือ',
  1031: 'รายได้รวมโดยประมาณ',
  1032: 'การโอนเงิน',
  1033: 'ทั้งหมด',
  1034: 'ขีด จำกัด เดียว',
  1035: 'ค่าธรรมเนียมการจัดการ',
  1036: 'ฉันได้อ่านและตกลง',
  1037: 'ข้อตกลงการบริการการจัดการทางการเงินของแพลตฟอร์ม',
  1038: 'ตกลง',
  1039: 'ซื้อ',
  1040: 'ซื้อ',
  1041: 'ขาย',
  1042: 'การโอนเงินผ่านธนาคาร',
  1043: 'โปรดป้อนจำนวนเงิน',
  1044: 'หมวดหมู่สกุลเงิน Fiat',
  1045: 'จำนวนที่ขายได้',
  1046: 'จำนวนสูงสุดที่สามารถขายได้',
  1047: 'ทั้งหมด',
  1048: 'ราคาต่อหน่วยอ้างอิง',
  1049: 'วิธีการชำระเงินของคุณ',
  1050: 'ชื่อธนาคาร',
  1051: 'หมายเลขบัญชีธนาคาร',
  1052: 'ชื่อ',
  1053: 'คุณไม่ได้ผูกมัดวิธีการชำระเงินที่เกี่ยวข้องและไม่สามารถขายได้',
  1054: 'บันทึกคำสั่งซื้อ',
  1055: 'ตัวกรอง',
  1056: 'ประเภท',
  1057: 'สถานะ',
  1058: 'กำลังดำเนินการ',
  1059: 'ผ่าน',
  1060: 'ล้มเหลว',
  1061: 'ปริมาณ',
  1062: 'ความสำเร็จ',
  1063: 'การปฏิบัติงาน',
  1064: `คำนวณผลลัพธ์ของวันนี้`,
  1065: 'รายได้สะสม',
  1066: 'คำสั่งในอารักขา',
  1067: 'ไม่ได้เปิดบัญชีที่เชื่อถือ',
  1068: 'เปิดบัญชีทรัสต์สำหรับการสื่อสาร เพลิดเพลินไปกับรายได้ที่มั่นคง และทำให้การแข็งค่าของสินทรัพย์ง่ายขึ้น',
  1069: 'สมัครเพื่อเปิดใช้งานหมายความว่าคุณได้อ่านและตกลง',
  1070: '"ข้อตกลงการบริการการจัดการทางการเงินของแพลตฟอร์ม"',
  1071: 'สมัครเพื่อเปิดใช้งาน',
  1072: 'ยกเลิก',
  1073: 'กำลังดำเนินการ...',
  1074: 'การไถ่ถอน',
  1075: 'คุณแน่ใจหรือว่าต้องการแลกมัน?',
  1076: 'การไถ่ถอนก่อนกำหนดต้องชำระเงินค่าเสียหายที่ชำระบัญชี ซึ่งจะถูกหักในครั้งนี้ตามประเภทการจัดการทางการเงินของคุณ',
  1077: ' ,ยืนยันการแลกรางวัลแล้วหรือยัง',
  1078: 'ส่ง',
  1079: 'โปรดป้อนรหัสยืนยัน',
  1080: 'พร้อมท์',
  1081: 'กำไร',
  1082: 'เวลา',
  1083: 'เพิ่มวิธีการชำระเงินตามสกุลเงินตามกฎหมาย',
  1084: 'สถานะการสั่งซื้อ',
  1085: 'สกุลเงิน',
  1086: 'จำนวนสกุลเงินตามกฎหมาย',
  1087: 'หมายเลขบัญชีธนาคาร',
  1088: 'วิธีการเก็บเงินแบบอ้วน',
  1089: 'เพิ่มวิธีการรวบรวม',
  1090: 'วิธีการชำระเงินที่มีอยู่',
  1091: 'สกุลเงินคำสั่ง',
  1092: 'รหัสธนาคาร',
  1093: 'คุณแน่ใจหรือไม่ว่าต้องการลบวิธีการชำระเงิน',
  1094: 'โปรดป้อนหมายเลขบัญชีธนาคาร',
  1095: 'โปรดป้อนชื่อธนาคาร',
  1096: 'โปรดป้อนสกุลเงินตามกฎหมาย',
  1097: 'กรุณาเลือก',
  1098: 'กรุณาใส่ชื่อของคุณ',
  1099: 'สาขา',
  1100: 'ไม่จำกัด',
  1101: 'คุณยังไม่ได้ยืนยันชื่อจริงของคุณ',
  1102: 'สมุดปกขาว',
  1103: 'คุณลักษณะของเรา',
  1104: 'เราปลอดภัย',
  1105: 'พวกเราแข็งแกร่งมาก',
  1106: 'การสนับสนุนที่ดีที่สุด',
  1107: 'เราเป็นสากล',
  1108: 'มันทำงานอย่างไร',
  1109: 'ผู้ใช้ในกว่า 20 ประเทศและภูมิภาคกำลังใช้แพลตฟอร์มของเราและเป็นที่รู้จักอย่างกว้างขวาง',
  1110: 'การเข้ารหัสข้อมูลขั้นสูง',
  1111: 'สกุลเงินดิจิตอลที่หลากหลาย',
  '1111_2': 'โลหะมีค่าและสกุลเงินดิจิทัลที่หลากหลาย',
  1112: '90+ Cryptocurrencies ที่ระบุไว้',
  1113: 'ข้อมูลการทำธุรกรรมของคุณได้รับการรักษาความปลอดภัยผ่านการเข้ารหัสแบบ end-to-end เพื่อให้มั่นใจว่ามีเพียงคุณเท่านั้นที่สามารถเข้าถึงข้อมูลส่วนบุคคลของคุณได้',
  1114: '43 พันล้าน',
  1115: 'ปริมาณการซื้อขาย 24 ชั่วโมง',
  1116: '30 ล้าน',
  1117: 'ผู้ใช้ที่ลงทะเบียนที่ไว้วางใจเรา',
  1118: 'ค่าธรรมเนียมการทำธุรกรรมต่ำสุด',
  1119: 'ดาวน์โหลด',
  1120: 'ชื่อสถาบันการเงิน',
  1121: 'ชื่อสาขา',
  1122: 'หมายเลขสำนักงานสาขา',
  1123: 'หมายเลขบัญชี',
  1124: 'ชื่อผู้รับ',
  1125: 'คินโจ',

  1148: 'แพลตฟอร์ม Cryptocurrency ที่น่าเชื่อถือที่สุด',
  1149: 'นี่คือเหตุผลที่คุณควรเลือกเรา',
  1150: 'เราปลอดภัย',
  1151: 'เทคโนโลยีความเป็นส่วนตัวและการรักษาความลับที่ปราศจากอคติที่ไม่มีอคติในการปกป้องความเป็นส่วนตัวของผู้ใช้ หลายลายเซ็น สถาปัตยกรรมแบบเลเยอร์ และการออกแบบความปลอดภัยอื่นๆ',
  1152: 'การสนับสนุนที่ดีที่สุด',
  1153: 'โหมดการทำงานเต็มเวลาตลอด 24 * 7 ชั่วโมง ฝ่ายบริการลูกค้าจะตอบคำถามที่เกี่ยวข้องของคุณโดยเร็วที่สุด',
  1154: 'พวกเราคือ Global',
  1155: 'ผู้ใช้ในกว่า 20 ประเทศและภูมิภาคกำลังใช้แพลตฟอร์มของเราและได้รับการยอมรับอย่างกว้างขวาง',
  1156: 'พวกเราแข็งแกร่ง',
  1157: 'แพลตฟอร์มการซื้อขายสินทรัพย์ดิจิทัลยอดนิยม เข้าถึงการวิเคราะห์ทางเทคนิคและเครื่องมือการซื้อขายที่ทรงพลังและสะดวกสบายที่สุดในตลาด ',
  1158: 'หลากหลายสกุลเงินดิจิทัล',
  1159: '90+ Cryptocurrencies ที่ระบุไว้',
  1160: 'การเข้ารหัสข้อมูลขั้นสูง',
  1161: 'ข้อมูลธุรกรรมของคุณได้รับการรักษาความปลอดภัยด้วยการเข้ารหัสแบบ end-to-end เพื่อให้มั่นใจว่ามีเพียงคุณเท่านั้นที่สามารถเข้าถึงข้อมูลส่วนบุคคลของคุณได้',
  1162: 'เรารองรับสกุลเงินดิจิทัลยอดนิยมที่หลากหลาย',
  1163: 'หลายประเทศได้จัดตั้งธุรกรรมที่แปลเป็นภาษาท้องถิ่น',
  1164: 'ใช้สกุลเงินที่ถูกกฎหมายเพื่อซื้อสินทรัพย์ดิจิทัลและเข้าสู่โลกของสินทรัพย์ดิจิทัลอย่างรวดเร็ว',
  1165: 'เทรดเพื่อไปทุกที่ทุกเวลา',
  1166: 'สแกนฉันเพื่อดาวน์โหลด',
  1167: 'อัตราแลกเปลี่ยน',
  1168: 'ซื้อและขาย 250+ cryptocurrencies พร้อมอัพโหลดอัตราแลกเปลี่ยนเมื่อเร็ว ๆ นี้',
  1169: 'ไม่พลาดทุกความเคลื่อนไหวด้วยแอพและไคลเอนต์เดสก์ท็อปของเรา',
  1170: 'ชื่อ',
  1171: 'ราคา',
  1172: 'เปลี่ยน',
  1173: 'แผนภูมิ',
  1174: 'ซื้อขาย',
  1175: 'รายละเอียด',
  1176: 'คือ',
  1177: 'ปลอดภัย',
  1178: 'เรามี',
  1179: 'ทั่วโลก',
  1180: 'ทรงพลัง',
  1181: 'หลากหลาย',
  1182: 'สกุลเงินดิจิตอล',
  1183: 'ข้อมูลขั้นสูง',
  1184: 'การเข้ารหัส',
  1185: 'พร้อมที่จะเริ่มต้น',
  1186: 'เราเป็นแพลตฟอร์มการซื้อขายสินทรัพย์ดิจิทัลชั้นนำของโลก ',
  1187: 'เราเป็นแพลตฟอร์มการซื้อขายสินทรัพย์ดิจิทัลชั้นนำของโลก เราพยายามปรับปรุงคุณสมบัติการรักษาความปลอดภัยอย่างต่อเนื่องเพื่อให้มั่นใจในความปลอดภัยของทรัพย์สินดิจิทัลของลูกค้า โมเดลของเราคือการนำลูกค้าโครงการที่มีมูลค่าที่ยั่งยืน',

  1188: 'อุปทานทั้งหมด',
  1189: '24*7 โหมดการทำงานเต็มเวลาทุกสภาพอากาศ ฝ่ายบริการลูกค้าจะตอบคำถามที่เกี่ยวข้องให้คุณโดยเร็วที่สุด',
  1190: 'เราเป็นสากล',
  1191: 'พวกเราแข็งแกร่ง',
  1192: 'แพลตฟอร์มการซื้อขายสินทรัพย์ดิจิทัลที่ได้รับความนิยมมากที่สุด รับการวิเคราะห์ทางเทคนิคและเครื่องมือการซื้อขายที่ทรงพลังและสะดวกสบายที่สุดในตลาด',
  1193: 'สกุลเงินดิจิตอลที่หลากหลาย',
  1194: 'ข้อมูลการทำธุรกรรมของคุณได้รับการปกป้องด้วยการเข้ารหัสแบบ end-to-end ทำให้มั่นใจได้ว่ามีเพียงคุณเท่านั้นที่สามารถเข้าถึงข้อมูลส่วนบุคคลของคุณได้',
  1195: 'ค่าธรรมเนียมการทำธุรกรรมขั้นต่ำ',
  1196: 'ไว้วางใจผู้ใช้ที่ลงทะเบียนของเรา',
  1197: 'ปริมาณการซื้อขายตลอด 24 ชั่วโมง',
  1198: '+42 พันล้าน',
  1199: '+30 ล้าน',
  1200: 'หลายประเทศได้จัดตั้งศูนย์บริการธุรกรรมที่แปลเป็นภาษาท้องถิ่นเพื่อสร้างระบบนิเวศบล็อคเชนที่รวมรูปแบบธุรกิจที่หลากหลาย',
  1201: 'ใช้สกุลเงิน fiat เพื่อซื้อสินทรัพย์ดิจิทัลและเข้าสู่โลกของสินทรัพย์ดิจิทัลอย่างรวดเร็ว',
  1202: 'ดาวน์โหลดแอป',
  1203: 'ข้อได้เปรียบของเรา',
  1204: 'ข้อมูลสกุลเงินและสกุลเงินที่หลากหลาย ให้สกุลเงิน สัญญา ธุรกรรมสกุลเงินตามกฎหมาย และวิธีการธุรกรรมอื่นๆ ตลาดมืออาชีพและเชิงลึก',
  1205: "การซื้อขายทันที",
  1206: "เงินประกันเพิ่มเติม",
  1207: "บัญชีการเงิน",
}
